import { makeAutoObservable, runInAction } from 'mobx';

import {cmApi } from '@src/api';
import type { CmApi} from '@src/api';

import { preloaderStore } from '../../preloaderStore';

export interface OrgBusinessTypesDto {
  businessTypeCode: string;
  businessTypeDescription: string;
}

type OrganizationTypeDtoDefId = OrgBusinessTypesDto & { id: number };

class OrgBusinessTypesStore {
  orgBusinessTypes: OrganizationTypeDtoDefId[] = [];

  api: CmApi;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  fetch = async (signal?: AbortSignal): Promise<void> => {
    preloaderStore.preloader(true);
    const { data } = await this.api.organizationBusinessTypes.getOrganizationBusinessTypes({ signal: signal });

    runInAction(() => {
      this.orgBusinessTypes = data?.map((org) => ({ ...org, id: org.businessTypeCode ?? -1 })) ?? [];
    });
    preloaderStore.preloader(false);
  };
}

export const orgBusinessTypesStore = new OrgBusinessTypesStore({ api: cmApi });
